import {
  doGETRequest,
  doPOSTRequest,
  doPUTRequest,
  doDELETERequest,
  doMultipartPOSTRequest
} from "./Api";
import { OrderItemAction } from "./dto/OrderItemAction";

class OrderApi {
  
  public static async createOrUpdate(data: any) {
    if(data.id) {
      return this.update(data);
    }
  }

  public static async update(data: any) {
    const relativePath = "/orders";
    var response = await doPUTRequest(relativePath, data);
    return response;
  }
  
  public static async listAll() {
    const relativePath = "/orders";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async filterAndList(filterDTO:any) {
    const relativePath = "/orders/filter";
    var response = await doPOSTRequest(relativePath,filterDTO);
    return response;
  }

  public static async filterByOperationTypeAndList(operationType:any) {
    const relativePath = "/orders/filter?operationType="+operationType;
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async cancelOrderItem(orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/cancel";
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async applyOrderItemAction(action:any, orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"?action="+action;
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async applyOrderItemLoadAction(orderId:Number, orderItemId:Number, loadItemDTO:any) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/load?action=LOAD_ITEM_TO_TRUCK";
    var response = await doPUTRequest(relativePath, loadItemDTO);
    return response;
  }

  public static async approveOrderItem(orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"?action=APPROVE";
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async takeBackFromWareHouse(orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"?action="+OrderItemAction[OrderItemAction.TAKE_BACK_FROM_WAREHOUSE];
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async approveOrderItemPartially(orderId:Number, orderItemId:Number, quantity:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"?action=APPROVE_PARTIALLY&quantity="+quantity;
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async prepareOrderItem(orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/prepare";
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async doReadyForLoadingOrderItem(orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/ready-for-loading";
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async loadedToTruck(orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/loaded-to-truck";
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async loadedToTruckWithWarehouses(orderId:Number, orderItemId:Number, shippingId:Number, warehouses:Array<any>) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/loaded-to-truck/"+shippingId;
    var response = await doPUTRequest(relativePath, warehouses);
    return response;
  }

  public static async acceptLoadStatus(orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/accept-load-status";
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async rejectLoadStatus(orderId:Number, orderItemId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/reject-load-status";
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async listByQuery(query:any) {
    const relativePath = "/orders/filter-by-query";
    var response = await doPOSTRequest(relativePath, query);
    return response;
  }

  public static async planShipmentVehicleForOrder(orderId:Number, vehicleId:Number) {
    const relativePath = "/orders/"+orderId+"/plan-shipment-vehicle";
    var response = await doPUTRequest(relativePath, {vehicleId:vehicleId});
    return response;
  }

  public static async filterGroupedByBuyerAndWarehouse(filterDTO: any) {
    const relativePath = "/orders/query/grouped";
    const response = await doPOSTRequest(relativePath, filterDTO);
    return response;
  }


  public static async planShipmentVehicleForOrderItem(orderId:Number, orderItemId:Number, vehicleId:Number) {
    const relativePath = "/orders/"+orderId+"/order-item/"+orderItemId+"/plan-shipment-vehicle";
    var response = await doPUTRequest(relativePath, {vehicleId:vehicleId});
    return response;
  }

  public static async estimatePaletteCount(orderId:Number, count:Number) {
    const relativePath = "/orders/"+orderId+"/estimate-palette-count";
    var response = await doPUTRequest(relativePath, {count:count});
    return response;
  }

  public static async getOrderItemsByStatus(status: string) {
    const relativePath = `/orders/order-item/${status}`;
    return await doGETRequest(relativePath);
  }

  public static async listByQueryPaged(query:any) {
    const relativePath = "/orders/filter-by-query-page";
    var response = await doPOSTRequest(relativePath, query);
    return response;
  }

  public static async previewLogoXml(file: File) {
    const relativePath = "/orders/import/logo-xml/preview";
    const formData = new FormData();
    formData.append("file", file);
    return await doMultipartPOSTRequest(relativePath, formData);
  }

  public static async confirmLogoXml(
    previewToken: string,
    selectedLineIds: string[],
    buyerWarehouseOverrides: { lineId: string; buyerWarehouseId: number }[] = [],
  ) {
    const relativePath = "/orders/import/logo-xml/confirm";
    return await doPOSTRequest(relativePath, { previewToken, selectedLineIds, buyerWarehouseOverrides });
  }

  public static async deleteBulk(orderIds: number[]) {
    const relativePath = "/orders/admin/delete-selected";
    return await doPOSTRequest(relativePath, orderIds);
  }

  public static async deleteAll() {
    const relativePath = "/orders/admin/delete-all";
    return await doDELETERequest(relativePath, null);
  }

}

export default OrderApi;
